import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[200],
    marginTop: 10
  },
  upSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    padding: 12,
    paddingBottom: 0,
    gap: 24,
    [theme.breakpoints.down(1025)]: {
      display: 'flex',
      gap: '7px',
      flexDirection: 'column'
    }
  },
  actionsTypeSelector: {
    width: '100%'
  },
  amountContainer: {
    width: '100%'
  },
  radioButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(1025)]: {
      marginTop: 32,
      marginBottom: 14,
      justifyContent: 'space-between'
    },
    [theme.breakpoints.down(480)]: {
      marginTop: 36,
      marginBottom: 32,
      alignItems: 'flex-start',
      flexDirection: 'column'
    }
  },
  currencyContainer: {
    width: 110,
    display: 'flex',
    alignItems: 'center',
    gap: 5
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap'
    // flex: 1
  },
  middleSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    padding: '0px 12px',
    gap: 24,
    [theme.breakpoints.down(1025)]: {
      display: 'flex',
      gap: '7px',
      flexDirection: 'column'
    }
  },
  downSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 2.06fr',
    padding: '0px 12px',
    gap: 24,
    [theme.breakpoints.down(1025)]: {
      display: 'flex',
      gap: '7px',
      flexDirection: 'column',
      marginTop: 12
    }
  },
  descriptionTextArea: {
    marginTop: -6
  },
  checkBoxContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 24,
    paddingBottom: 24
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  menuItemRight: {
    direction: 'ltr'
  }
}))

export default useStyles
